import React from "react";
import { useCurrentUserStore } from "@src/state/currentUserState";
import Roles from "@src/constants/Roles";
import ClinicPortalContainer from "@src/components/containers/ClinicPortalContainer";
import BasePortalContainer from "@src/components/containers/BasePortalContainer";

export default function AppContainer(): React.JSX.Element {
  const { currentUser } = useCurrentUserStore();

  if (currentUser?.role === Roles.ClinicUser) {
    return <ClinicPortalContainer />;
  }

  return <BasePortalContainer />;
}
